import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAttributes } from '@hozana/dom/hooks/useAttributes'
import { QA } from '@hozana/tests/constants'

import { Div } from 'elements/layout/Div'
import { Icon } from 'elements/media/Icon'
import { Ellipsis } from 'elements/text/Ellipsis'
import { Link, TLinkProps } from 'elements/text/Link'

import { ICON } from 'config/icons'
import { DONATION_SOURCE } from 'general/constants'
import { newRoutes } from 'routes/constants'

import { NavigationLi } from './NavigationLi'

export const MainLinkDonate: TFCC<TLinkProps & { light?: boolean; source: DONATION_SOURCE }> = ({
  light,
  source,
  ...otherProps
}) => {
  const attrs = useAttributes() // used for accessibility to pass "tabindex = -1" to avoid focus
  const hoverBg = light ? 'fadedWhite10' : 'background'
  const {
    i18n: { language },
  } = useTranslation()

  return (
    <NavigationLi hoverBg={hoverBg}>
      <Link
        color={light ? 'white' : 'darkRed'}
        hoverColor="darkRed"
        w="100%"
        data-testid={QA.COMMON.NAVIGATION.DONATE_LINK}
        to={newRoutes.donateAuto({ locale: language, source })}
        reload
        {...attrs}
        {...otherProps}
      >
        <Div p="16px 12px" align="middleLeft">
          <Icon name={ICON.HEART} size="24px" color="darkRed" m="0 16px 0 0" />
          <Ellipsis bold>trans:common:app.i-donate</Ellipsis>
        </Div>
      </Link>
    </NavigationLi>
  )
}
